package br.com.texeratx.boardgametimeapp.core.active_match

/**
 * Estado observado pela UI.
 *
 * A UI não calcula tempo. Ela só exibe o estado pronto.
 */
sealed interface ActiveMatchState {

    data object Idle : ActiveMatchState

    data class Running(
        val match: ActiveMatch,
        val elapsedMillis: Long,
        val formattedElapsed: String
    ) : ActiveMatchState

    data class Paused(
        val match: ActiveMatch,
        val elapsedMillis: Long,
        val formattedElapsed: String
    ) : ActiveMatchState

    data class Finished(
        val match: ActiveMatch,
        val totalElapsedMillis: Long,
        val formattedElapsed: String
    ) : ActiveMatchState
}
